import { gql } from '@apollo/client';

export const RegisterStudentAnonymouslyMutation = gql`
    mutation RegisterStudentAnonymously($args: RegisterStudentAnonymouslyArgs!) {
        registerStudentAnonymously(args: $args) {
            accessToken
            refreshToken
            redirectUrl
        }
    }
`;
